<template>
  <div class="box">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-layout
      d-block
      d-md-flex
      row
      ma-0
      align-center
      justify-space-between
      class="box-header"
    >
      <h3>{{ $t("validate-audit.title-1") }}</h3>
    </v-layout>
    <div class="box-content">

      <div class="d-flex align-items-center justify-center mt-4">
        <v-btn
          class="mx-2"
          rounded
          elevation="0"
          color="primary"
          @click="validate('json')"
          >{{ $t("validate-audit.btn-2") }}</v-btn>
        <v-btn
          class="mx-2"
          rounded
          elevation="0"
          color="error"
          @click="reject"
          >{{ $t("validate-audit.btn-3") }}</v-btn>
      </div>

      <!-- <div
        v-if="showDlBtn"
        class="d-flex align-items-center justify-center mt-2"> -->
      <div
        class="d-flex align-items-center justify-center mt-2">
        <!-- <v-btn
          class="ma-2"
          rounded
          elevation="0"
          small
          color="primary"
          @click="PDFfn"
          :loading="loadPDF"
          >{{ $t("validate-audit.btn-4") }}</v-btn> -->
        <v-btn
          class="ma-2"
          rounded
          outlined
          small
          elevation="0"
          color="primary"
          :disabled="pdf ? false : true"
          :href="pdf"
          :download="unescaped(survey.info[`title_${$i18n.locale}`])"
          >{{ $t("validate-audit.btn-4") }}</v-btn>
        <v-btn
          class="ma-2"
          rounded
          outlined
          small
          elevation="0"
          color="primary"
          :disabled="pdffull ? false : true"
          :href="pdffull"
          :download="unescaped(survey.info[`title_${$i18n.locale}`])"
          target="_blank"
          >{{ $t("validate-audit.btn-5") }}</v-btn>
      </div>

      <v-data-table
        :headers="headers"
        :items="tableItems"
        calculate-widths
        disable-pagination
        disable-sort
        disable-filtering
        hide-default-footer
      ></v-data-table>
    </div>

    <v-dialog
      v-model="showDialog"
      max-width="500"
    >
      <v-card class="ma-0">
        <v-card-title class="headline">
          <div class="headline" v-html="$t('validate-audit.validate-dialog.title')"></div>
        </v-card-title>

        <v-card-text>{{ $t('validate-audit.validate-dialog.description') }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            text
            color="error"
            @click="showDialog= false"
          >
            {{ $t('dashboard-screen.dialog.btn-1') }}
          </v-btn>
          <v-btn
            outlined
            rounded
            color="primary"
            @click="validate('force')"
          >
            {{ $t('dashboard-screen.dialog.btn-2') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validateAudit } from '@/js/survey/validate/validateAudit'
import { rejectAudit } from '@/js/survey/validate/rejectAudit'
import { makePDF } from '@/js/utils/makePDF'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  props: {
    survey: Array | Object
  },
  components: {
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      headers: [
        { text: this.$t("validate-audit.col-1"), value: 'name'},
        { text: this.$t("validate-audit.col-2"), value: 'vetted'},
        { text: this.$t("validate-audit.col-3"), value: 'filled'},
        { text: this.$t("validate-audit.col-4"), value: 'max'}
      ],

      showDialog: false,
      showDlBtn: false,
      httpalert: false,

      loadPDF: false,

      // zip: this.$route.params.answerid && this.$store.state.auth.token ? randomBaseUrl(0, 3) + process.env.VUE_APP_DOWNLOAD_ZIP + `?options=json&answerid=${this.$route.params.answerid}&valid=${this.$store.state.auth.token}` : null,
      pdf: this.$route.params.answerid && this.$store.state.auth.token ? randomBaseUrl(0, 3) + process.env.VUE_APP_DOWNLOAD2_ZIP + `?&answerid=${this.$route.params.answerid}&lang=${this.$i18n.locale ? this.$i18n.locale : 'en'}&valid=${this.$store.state.auth.token}&options=pdf` : null,
      pdffull: this.$route.params.answerid && this.$store.state.auth.token ? randomBaseUrl(0, 3) + process.env.VUE_APP_DOWNLOAD2_ZIP + `?&answerid=${this.$route.params.answerid}&lang=${this.$i18n.locale ? this.$i18n.locale : 'en'}&valid=${this.$store.state.auth.token}` : null,
    }
  },

  computed: {
    tableItems () {
      var vettedInfo = [
        {
          name: this.$t("validate-audit.row-1"),
          vetted: this.survey.vetted.question,
          filled: this.survey.done.question,
          max: this.survey.total.question,
        },
        {
          name: this.$t("validate-audit.row-2"),
          vetted: this.survey.vetted.mandatoryq,
          filled: this.survey.done.mandatoryq,
          max: this.survey.total.mandatoryq,
        },
        {
          name: this.$t("validate-audit.row-3"),
          vetted: this.survey.vetted.point,
          filled: `${this.survey.done.point}/ ${this.survey.total.requiredpt}`,
          max: `${this.survey.total.point}/ ${this.survey.total.requiredpt}`,
        },
      ]
      return vettedInfo
    }
  },

  methods: {
    validate (options) {
      const params = {
        options: options ? options : null,
        answerid: this.$route.params.answerid,
        key: this.$route.params.validkey
      }
      validateAudit(params)
        .then(response => {
          this.showDialog = true
          if (response.data.status === 'ok' || response.data.status === 'OK') {
            // if not possible show alert to remake the call with force option
            this.showDialog = false
            this.showDlBtn = true

          } else {
            // do something
            this.showDialog = false
            this.httpalert = true
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
          }
        })
        .catch(error => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    reject () {
      const params = {
        answerid: this.$route.params.answerid,
        key: this.$route.params.validkey
      }
      rejectAudit(params)
        .then(response => {
          if (response.data.status === 'error') {
            this.httpalert = true
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
          } else {
            // do something
          }
        })
        .catch(error => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    PDFfn (val) {
      // if (!this.$store.getters['auth/isAuthenticated']) return
      this.loadPDF = true
      makePDF(val, this.answerid, this.$store.state.auth.token, this.firm)
        .then(() => {
          this.loadPDF = false
          this.dialog = false
        })
        .catch(() => {
          this.httpalert = true
          this.loadPDF = false
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    },

    unescaped (string) {
      var txt = document.createElement('textarea')
      txt.innerHTML = string
      return txt.value
    }
  }

  // created () {
  //   console.log(this.survey)
  // }
}
</script>
